import { render, staticRenderFns } from "./UserNotAuthorized.vue?vue&type=template&id=20d109ee&scoped=true&"
import script from "./UserNotAuthorized.vue?vue&type=script&lang=js&"
export * from "./UserNotAuthorized.vue?vue&type=script&lang=js&"
import style0 from "./UserNotAuthorized.vue?vue&type=style&index=0&id=20d109ee&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d109ee",
  null
  
)

export default component.exports